@for (option of $any(props.options); track option; let i = $index) {
<ion-item lines="none">
  <ion-checkbox mode="md" [id]="id + '_' + i" [taFormlyAttributes]="field" [ariaLabel]="option.value"
    [checked]="formControl.value[option.key]" (ionChange)="onChange(option.key, $any($event.target).checked)"
    legacy="true" labelPlacement="start">
    <div class="ion-text-wrap ion-font-sm">{{ option.value }}</div>
  </ion-checkbox>
</ion-item>
}